import React from "react";
import { Route, Routes as RouterRoutes, useLocation } from "react-router-dom";
import UserHeader from "../containers/components/Header/UserHeader";
import EntryDetailsPage from "../features/entry-exit/pages/Entry/EntryDetailsPage";
import ExitDetailsPage from "../features/entry-exit/pages/Exit/ExitDetailsPage";
import GateSelectionPage from "../features/entry-exit/pages/GateSelectionPage";
import VehicleTypeSelectionPage from "../features/entry-exit/pages/VehicleTypeSelectionPage";
import UserHomePage from "../features/home/UserHomePage";
import LandingPage from "../features/main/LandingPage";
import Reports from "../features/reports/Reports";
import RequireAuth from "./RequireAuth";
import HomePage from "../features/home/HomePage";
import FloorPage from "../features/masters/pages/FloorPage";
import BlockMasterPage from "../features/masters/pages/BlockMasterPage";
import SlotPage from "../features/masters/pages/SlotPage";
import Attendence from "../features/reports/pages/Attendence";
import Collections from "../features/reports/pages/Collections";
import FeeMasterPage from "../features/masters/pages/FeeMasterPage";
import VehiclePage from "../features/masters/pages/VehiclePage";
import ParkingType from "../features/masters/pages/ParkingType";
import PaymentModePage from "../features/masters/pages/PaymentModePage";
import TransactionsPage from "../features/reports/pages/TransactionsPage";
import DateDetailsTable from "../features/reports/components/DateDetailsTable";
import GateMasterPage from "../features/masters/pages/GateMasterPage";
import StaffOnBoard from "../features/masters/pages/StaffOnBoard";
import ExitBoothMasterPage from "../features/masters/pages/ExitBoothMasterPage";
import ShiftMasterPage from "../features/masters/pages/ShiftMasterPage";
import MainLayout from "../containers/MainLayout";
import ShiftTypePage from "../features/masters/pages/ShiftTypePage";
import CashCollectReportPage from "../features/reports/pages/CashCollectReportPage";
import LocationMaster from "../features/masters/pages/LocationMaster";
import ShiftPage from "../features/masters/pages/ShiftMaster/ShiftPage";
import ShiftAssignPage from "../features/masters/pages/ShiftMaster/ShiftAssignPage";
import ShiftHistoryPage from "../features/masters/pages/ShiftMaster/ShiftHistoryPage";
import StaffOnboardPage from "../features/masters/pages/StaffManagement/StaffOnboardPage";
import Test from "../containers/components/Nav/Test";
import CashCollectDetailReportPage from "../features/reports/pages/CashCollectDetailReportPage";
import RefundReports from "../features/home/components/RefundReports";
import ExtraChargesMasterPage from "../features/masters/pages/ExtraChargesMasterPage";
import ChangeLogoInDashbaordPage from "../features/settings/pages/ChangeLogoInDashbaordPage";
import AvailableSlotsForCars from "../features/entry-exit/pages/AvailableSlots/AvailableSlotsForCars";
import AvailableSlotsForBikes from "../features/entry-exit/pages/AvailableSlots/AvailableSlotsForBikes";
import SettlementReport from "./../features/reports/pages/SettlementReport";
import ComplimentaryDetails from "../features/reports/pages/ComplimentaryDetails";
import ParkingTypeReport from "../features/reports/pages/ParkingTypeReport";
import PrivacyPolicy from "../features/privacyPolicy/pages/ProivacyPolicy";
import AreaMasterPage from "../features/masters/pages/AreaMasterPage";
import SlotCountMasterPage from "../features/masters/pages/SlotCount";

const Routes = () => {
  const { state } = useLocation();
  return (
    <RouterRoutes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      {/* require Auth ------------------------------- */}
      <Route element={<RequireAuth />}>
        <Route element={<UserHeader />}>
          <Route path="/home" element={<UserHomePage />} />
          <Route path="/home/:gateName" element={<GateSelectionPage />} />
          <Route
            path="/home/:gateName/:gateId"
            element={<VehicleTypeSelectionPage />}
          />
          <Route
            path="/home/entry-gate/:gateId/vehicle/:vehicleId"
            element={<EntryDetailsPage />}
          />
          <Route
            path="/home/exit-gate/:gateId/vehicle/:vehicleId"
            element={<ExitDetailsPage />}
          />
        </Route>

        <Route path="/entry" element={<EntryDetailsPage />} />
        <Route path="/exit" element={<ExitDetailsPage />} />

        {/* layout ------------------------------- */}
        <Route element={<MainLayout />}>
          <Route path="/location-master" element={<LocationMaster />} />
          <Route
            path="/profile-settings"
            element={<ChangeLogoInDashbaordPage />}
          />
          <Route path="/transaction" element={<TransactionsPage />} />
          <Route path="/collections" element={<Collections />} />
          <Route path="/slotcount" element={<SlotCountMasterPage />} />
          <Route path="/attendence" element={<Attendence />} />
          <Route path="/cashcollect" element={<CashCollectReportPage />} />
          <Route path="/transaction/view" element={<DateDetailsTable />} />
          <Route path="/shiftmaster/assign" element={<ShiftAssignPage />} />
          <Route path="/parking-type" element={<ParkingTypeReport />} />
          <Route path="/shiftmaster/history" element={<ShiftHistoryPage />} />
          <Route path="/reports" element={<Reports />} />
          <Route
            path="/cashcollect/view/:id"
            element={<CashCollectDetailReportPage />}
          />
          <Route path="/vehicle" element={<VehiclePage />} />
          <Route path="/staffonboard" element={<StaffOnBoard />} />
          <Route path="/slot" element={<SlotPage />} />
          <Route path="/paymentmode" element={<PaymentModePage />} />
          <Route path="/staffonboarding" element={<StaffOnboardPage />} />
          <Route path="/parkingtype" element={<ParkingType />} />
          <Route path="/dashboard" element={<HomePage />} />
          <Route path="/floor" element={<FloorPage />} />
          <Route path="/entrybooth" element={<GateMasterPage />} />
          <Route path="/area" element={<AreaMasterPage />} />
          <Route path="/fee" element={<FeeMasterPage />} />
          <Route path="/extra-charges" element={<ExtraChargesMasterPage />} />
          <Route path="/exitbooth" element={<ExitBoothMasterPage />} />
          {/* <Route path="/block" element={<BlockMasterPage />} /> */}
          <Route path="/settlement-report" element={<SettlementReport />} />
          <Route path="/shift-master" element={<ShiftMasterPage />} />

          <Route path="/shift-type" element={<ShiftTypePage />} />
          <Route path="/shiftmaster/test" element={<Test />} />
          <Route path="/shiftmaster" element={<ShiftPage />} />
          <Route
            path="/complimentary-details"
            element={<ComplimentaryDetails />}
          />
        </Route>
      </Route>
      <Route element={<MainLayout />}>
        <Route
          path={
            state?.vehicle === "car_dsh"
              ? "/cars-refund-report/:id"
              : "/bikes-refund-report/:id"
          }
          element={<RefundReports />}
        />
        <Route
          path="/complimentary-details"
          element={<ComplimentaryDetails />}
        />
      </Route>
      <Route path="/vehicle/:vehicleType" element={<AvailableSlotsForCars />} />
      <Route path="/cars" element={<AvailableSlotsForCars />} />
      <Route path="/bikes" element={<AvailableSlotsForBikes />} />
    </RouterRoutes>
  );
};

export default Routes;
